import { firstUnitOf, type Amount, type Food } from '~/data/nutrition'

/**
 * The amount a food opens on: what it was last logged in, or one portion where it has one,
 * or a hundred of the first of its units where it never was — millilitres on a liquid.
 */
export function openingAmount(food: Food, last: Amount | null): Amount {
  if (
    last !== null &&
    (last.unit !== 'portion' || food.portions.some((p) => p.name === last.portion))
  ) {
    return last
  }
  const first = food.portions[0]
  if (first !== undefined) {
    return { value: 1, unit: 'portion', portion: first.name }
  }
  return { value: 100, unit: firstUnitOf(food), portion: null }
}
